import { PreferredLanguage } from "../../../enums";

export interface UserDetails {
  username?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  lastPosition?: string | null;
  city?: string | null;
  jobSearchCity?: string | null;
  careerLevel?: string | null;
  othersDiscipline?: string | null;
  othersIndustry?: string | null;
  industry?: string | null;
  discipline?: string | null;
  timingLastDayAtWork?: Date | null;
  timingAchieveRestart?: Date | null;
  need?: string | null;
  pushNotifications?: boolean;
  jobRecommendations?: boolean;
  smsNotifications?: boolean;
  whatsappNotifications?: boolean;
  weeklyDigest?: boolean;
  discourseNotifications?: boolean;
  birthday?: string | null;
  journeyId?: string | null;
  newJobType?: string | "";
  newJobStartDate?: string | "";
  newJobTitle?: string | "";
  newJobComments?: string | "";
  jobHistories?: JobHistory[];
  mobilePhone?: string | null;
  whatsappOptIn?: boolean;
}

export interface UpdateVariables {
  userDetails: UserDetails;
}

export interface StepCareerParameters {
  lastPosition: string | null;
  careerLevel: string | null;
  industry: string | null;
  discipline: string | null;
}

export interface StepBlueCareerParameters {
  lastPosition: string | null;
  experienceInYears: string | null;
  industry: string | null;
  jobHistories: JobHistory[];
}

export interface JobHistory {
  id?: number;
  lastPosition: string | null;
  experienceInYears: string | null;
  isCurrent?: boolean;
}

export interface StepNameParameters {
  firstName: string;
  lastName: string;
  birthday: string | null;
  mobilePhone: string | null;
  city: string | null;
  preferredLanguage: string;
}

export interface StepJourneyParameters {
  journeyId?: string;
}

export interface StepSituationParameters {
  terminationState: string | null;
  terminationConditions: string | null;
}

export interface StepNeedsParameters {
  timingLastDayAtWork: Date | null;
  timingAchieveRestart: Date | null;
  need: string;
}

export interface StepBlueNeedsParameters {
  timingLastDayAtWork: Date | null;
  timingAchieveRestart: Date | null;
  need: string;
  whatsappOptIn: boolean;
  mobilePhone?: string | null;
}

export interface StepCareerProps {
  onNext: (data: StepCareerParameters) => void;
  onSkip: () => void;
  onBack?: () => void;
  initialData?: StepCareerParameters;
}

export interface StepBlueCareerProps {
  onNext: (data: StepBlueCareerParameters) => void;
  onSkip: () => void;
  onBack?: () => void;
  initialData?: StepBlueCareerParameters;
}

export interface StepNameProps {
  onNext: (data: StepNameParameters) => void;
  onSkip: () => void;
  initialData?: StepNameParameters;
}

export interface StepJourneyProps {
  onNext: (data: StepJourneyParameters) => void;
  onSkip: () => void;
  onBack?: () => void;
  availableJourneyIds?: {
    standardUserJourneyId: string;
    reorientationJourneyId: string;
  };
  initialData?: StepJourneyParameters;
}

export interface StepSituationProps {
  onNext: (data: StepSituationParameters) => void;
  onSkip: () => void;
  initialData?: StepSituationParameters;
}

export interface StepNeedsProps {
  onNext: (data: StepNeedsParameters) => void;
  onSkip: () => void;
  onBack?: () => void;
  selectedOption?: string;
  availableJourneyIds?: {
    standardUserJourneyId: string;
    reorientationJourneyId: string;
  };
  initialData?: StepNeedsParameters;
}

export interface StepBlueNeedsProps {
  onNext: (data: StepBlueNeedsParameters) => void;
  onSkip: () => void;
  onBack?: () => void;
  selectedOption?: string;
  availableJourneyIds?: {
    standardUserJourneyId: string;
    reorientationJourneyId: string;
  };
  initialMobilePhone?: string | null;
  initialData?: StepBlueNeedsParameters;
}

export interface SubmitStepProps {
  onNext: () => void;
  onBack?: () => void;
  selectedOption?: string;
  availableJourneyIds?: {
    standardUserJourneyId: string;
    reorientationJourneyId: string;
  };
}

export interface KeyValue {
  key: string;
  value: string;
}

export const getYearsOfExperienceRanges = (t: (key: string) => string) => [
  { key: "0-1", value: "0-1", label: `0-1 ${t("years")}` },
  { key: "2-4", value: "2-4", label: `2-4 ${t("years")}` },
  { key: "5-10", value: "5-10", label: `5-10 ${t("years")}` },
  { key: ">10", value: ">10", label: `>10 ${t("years")}` },
];
